import { useEffect, useState } from 'react';
import UM from '../../../utils/utilityMethods';

import "../../../../css/ui/popUps/ExchangeCurrency.css";

const ExchangeCurrency = (props) => {
    const [usd, setUsd] = useState('');
    const [tom, setTom] = useState('');
    const [isConverting, setIsConverting] = useState(false);
    const [conversionDirection, setConversionDirection] = useState(props?.preferred_wallet === "USD" ? 'usdToTom' : "tomToUsd");
    const [exchangeRate, setExchangeRate] = useState(0);
    const [walletInfo, setWalletInfo] = useState(null);
    const [multiplier, setMultiplier] = useState(1);
    const [isFlipping, setIsFlipping] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        if (!props.ExchangeInfo) return;

        const { MoneyExchangeInfo } = props.ExchangeInfo;
        const rate = MoneyExchangeInfo?.CurrencyRates?.CurrencyRate?.attr?.rate;
        const cash = MoneyExchangeInfo?.attr?.cash;
        const cash1 = MoneyExchangeInfo?.Balance?.attr?.cash;
        const multiplier = MoneyExchangeInfo?.CurrencyRates?.CurrencyRate?.attr?.multiplier || 1;
        console.log(MoneyExchangeInfo);

        setMultiplier(multiplier);
        setWalletInfo({
            rate: rate,
            balance: cash,
            anotherBalance: cash1
        });
        if (isConverting) {
            setError('Converted Successfully');
            setIsConverting(false);
        }
        if (rate !== undefined) {
            setExchangeRate(parseFloat(rate));
        }
    }, [props.ExchangeInfo, isConverting]);

    useEffect(() => {
        const walletType = conversionDirection === 'usdToTom' ? 'USD' : 'CHP';
        props.network?.send(`<GetMoneyExchangeInfo wallet='${walletType}' />`);
    }, [conversionDirection, props.network]);

    useEffect(() => {
        validateAmount();

        if (conversionDirection === 'usdToTom' && usd) {
            const usdValue = parseFloat(usd);
            if (!isNaN(usdValue)) {
                const converted = usdValue / exchangeRate;
                setTom(converted.toFixed(2));
            } else if (usd === '') {
                setTom('');
            }
        } else if (conversionDirection === 'tomToUsd' && tom) {
            const tomValue = parseFloat(tom);
            if (!isNaN(tomValue)) {
                const converted = tomValue * exchangeRate;
                setUsd(converted.toFixed(2));
            } else if (tom === '') {
                setUsd('');
            }
        }
    }, [usd, tom, conversionDirection, exchangeRate]);

    const validateAmount = () => {
        setError('');

        if (conversionDirection === 'usdToTom' && usd) {
            const usdValue = parseFloat(usd);
            const availableBalance = parseFloat(walletInfo?.balance || 0);

            if (isNaN(usdValue)) {
                setError('Please enter a valid amount');
                return false;
            }

            if (usdValue > availableBalance) {
                setError(`Amount exceeds available balance (${UM.numberWithCommas_length9(availableBalance)} USD)`);
                return false;
            }

            if (usdValue <= 0) {
                setError('Amount must be greater than 0');
                return false;
            }
        }

        if (conversionDirection === 'tomToUsd' && tom) {
            const tomValue = parseFloat(tom);
            const availableBalance = parseFloat(walletInfo?.balance || 0);

            if (isNaN(tomValue)) {
                setError('Please enter a valid amount');
                return false;
            }

            if (tomValue > availableBalance) {
                setError(`Amount exceeds available balance (${UM.numberWithCommas_length9(availableBalance)} TOM)`);
                return false;
            }

            if (tomValue <= 0) {
                setError('Amount must be greater than 0');
                return false;
            }
        }

        return true;
    };

    const handleConvert = () => {
        if (!validateAmount()) return;

        if ((conversionDirection === 'usdToTom' && !usd) ||
            (conversionDirection === 'tomToUsd' && !tom)) return;

        setIsConverting(true);
        const amount = conversionDirection === 'usdToTom' ? usd : tom;
        // props.network.send(`<ExchangeMoney wallet=${conversionDirection === 'usdToTom' ? "'USD'" : "'CHP'"}><Sources><ExchangeSource wallet=${conversionDirection !== 'usdToTom' ? "'USD'" : "'CHP'"} cash="${amount}" /></Sources></ExchangeMoney>`);
        props.network.send(`<ExchangeMoney wallet=${conversionDirection === 'usdToTom' ? "'USD'" : "'CHP'"}><Sources><ExchangeSource wallet=${conversionDirection !== 'usdToTom' ? "'USD'" : "'CHP'"} cash="${amount}" /></Sources></ExchangeMoney>`);
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleConvert();
        }
    };

    const toggleConversionDirection = () => {
        setIsFlipping(true);
        setTimeout(() => {
            setConversionDirection(prev => prev === 'usdToTom' ? 'tomToUsd' : 'usdToTom');
            setUsd('');
            setTom('');
            setIsFlipping(false);
            setError('');
        }, 300);
    };

    const clearValues = () => {
        setUsd('');
        setTom('');
        setError('');
    };

    const formatRate = (rate) => {
        return parseFloat(rate).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 6
        });
    };

    const handleInputChange = (value, isUsdInput) => {
        // Allow only numbers and decimal point
        if (value === '' || /^[0-9]*\.?[0-9]*$/.test(value)) {
            if (isUsdInput) {
                setUsd(value);
            } else {
                setTom(value);
            }
            setError('');
        }
    };

    
    return (
        <div className="exchange-container">
            <div className="exchange-header">
                <h2>Currency Exchange</h2>
                <div className="exchange-rate-display">
                    <div className={`rate-card ${isFlipping ? 'flipping' : ''}`}>
                        <div className="rate-front">
                            {conversionDirection === 'usdToTom' ? (
                                <>
                                    <span className="rate-value">{multiplier} USD =</span>
                                    <span className="rate-value highlight">{formatRate(1 / exchangeRate)} TOM</span>
                                </>
                            ) : (
                                <>
                                    <span className="rate-value">{multiplier} TOM =</span>
                                    <span className="rate-value highlight">{formatRate(exchangeRate)} USD</span>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <div className="wallet-balances">
                <div className="balance-card">
                    <span className="balance-label">Available {conversionDirection === 'usdToTom' ? "USD" : "TOM"}</span>
                    <span className="balance-amount">
                        {walletInfo ? UM.numberWithCommas_length9(walletInfo.balance) : '0.00'}
                    </span>
                </div>

                <button
                    className="flip-button"
                    onClick={toggleConversionDirection}
                    aria-label="Switch conversion direction"
                    title='Switch conversion direction'
                >
                    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="m320-160-56-57 103-103H80v-80h287L264-503l56-57 200 200-200 200Zm320-240L440-600l200-200 56 57-103 103h287v80H593l103 103-56 57Z" /></svg>
                </button>

                <div className="balance-card">
                    <span className="balance-label">Available {conversionDirection !== 'usdToTom' ? "USD" : "TOM"}</span>
                    <span className="balance-amount">
                        {walletInfo ? UM.numberWithCommas_length9(walletInfo.anotherBalance) : '0.00'}
                    </span>
                </div>
            </div>

            <div className="conversion-section">
                <div className="input-group">
                    <div className="input-card">
                        <label className="input-label">
                            {conversionDirection === 'usdToTom' ? 'USD Amount' : 'TOM Amount'}
                        </label>
                        <div className="input-field">
                            <span className="currency-symbol">
                                {conversionDirection === 'usdToTom' ? '$' : '₮'}
                            </span>
                            <input
                                type="text"
                                value={conversionDirection === 'usdToTom' ? usd : tom}
                                onChange={(e) => handleInputChange(e.target.value, conversionDirection === 'usdToTom')}
                                onKeyPress={handleKeyPress}
                                placeholder="0.00"
                                className="amount-input"
                            />
                            {(usd || tom) && (
                                <button
                                    className="clear-button"
                                    onClick={clearValues}
                                    aria-label="Clear amount"
                                >
                                    ×
                                </button>
                            )}
                        </div>
                    </div>
                </div>

                <div className="conversion-arrow">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="currentColor">
                        <path d="M450-200v-560L200-510l-60-60 330-330 330 330-60 60-250-250v560h-60Z" />
                    </svg>
                </div>

                <div className="result-group">
                    <div className="input-card result-card">
                        <label className="input-label">
                            {conversionDirection === 'usdToTom' ? 'TOM Amount' : 'USD Amount'}
                        </label>
                        <div className="input-field">
                            <span className="currency-symbol">
                                {conversionDirection === 'usdToTom' ? '₮' : '$'}
                            </span>
                            <input
                                type="text"
                                value={conversionDirection === 'usdToTom' ? UM.numberWithCommas_length9(tom) : UM.numberWithCommas_length9(usd)}
                                readOnly
                                placeholder="0.00"
                                className="result-input"
                            />
                        </div>
                    </div>
                </div>
            </div>

            {error && (
                <div className={`message ${error === "Converted Successfully" ? "success" : "error"}`}>
                    {error}
                </div>
            )
            }

            {
                (usd || tom) && !error && (
                    <div className="conversion-summary">
                        {usd && conversionDirection === 'usdToTom' && (
                            <div className="summary-text">
                                <span>{UM.numberWithCommas_length9(usd)} USD</span>
                                <span className="equals">=</span>
                                <span className="highlight">{UM.numberWithCommas_length9(tom)} TOM</span>
                            </div>
                        )}
                        {tom && conversionDirection === 'tomToUsd' && (
                            <div className="summary-text">
                                <span>{UM.numberWithCommas_length9(tom)} TOM</span>
                                <span className="equals">=</span>
                                <span className="highlight">{UM.numberWithCommas_length9(usd)} USD</span>
                            </div>
                        )}
                    </div>
                )
            }

            <button
                onClick={handleConvert}
                disabled={isConverting || (!usd && conversionDirection === 'usdToTom') || (!tom && conversionDirection === 'tomToUsd') || !!error}
                className={`convert-button ${isConverting ? 'converting' : ''}`}
            >
                {isConverting ? (
                    <>
                        <span className="exchange-spinner"></span>
                        Processing...
                    </>
                ) : (
                    'Confirm Exchange'
                )}
            </button>
        </div >
    );
};

export default ExchangeCurrency;